import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.type == 'code' ? _c('div', {
    staticClass: "field"
  }, [_vm.label ? [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _c('br')] : _vm._e(), _c('div', {
    staticClass: "euiElement"
  }, [_c('pre', [_vm._v(_vm._s(_vm.getValue || 'n.a.'))]), _vm.copy ? _c('span', {
    on: {
      "click": function ($event) {
        return _vm.copyToClipboard($event, _vm.value);
      }
    }
  }, [_c(VIcon, {
    staticClass: "clickable",
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-copy")])], 1) : _vm._e()])], 2) : _vm.type === 'textarea' ? _c('div', {
    staticClass: "field"
  }, [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]), _c('br'), _c('span', {
    staticClass: "value"
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.value) + "\n    ")])])]) : _vm.type === 'checkbox' ? _c('div', {
    staticClass: "field"
  }, [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]), _c('br'), _c('span', {
    staticClass: "value"
  }, [_vm.value ? _c('span', [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.field.yes')) + "\n    ")]) : _c('span', [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.field.no')) + "\n    ")])])]) : _vm.type === 'icon' ? _c('div', {
    staticClass: "field"
  }, [_vm.value ? _c('div', [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _c('br'), _c('span', {
    staticClass: "value"
  }, [_vm.icon ? _c('span', [_c(VIcon, {
    attrs: {
      "dark": "",
      "small": "",
      "color": _vm.iconColor || _vm.color
    }
  }, [_vm._v(_vm._s(_vm.iconType) + " " + _vm._s(`fa-${_vm.icon}`))]), _vm._v("\n         \n      ")], 1) : _vm._e(), _vm._t("value", function () {
    return [_vm._v("\n        " + _vm._s(_vm.value) + "\n      ")];
  })], 2)]) : _c('div', [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _c('br'), _c('span', {
    staticClass: "value"
  }, [_c(VIcon, {
    attrs: {
      "dark": "",
      "small": "",
      "color": _vm.iconColor || _vm.color
    }
  }, [_vm._v(_vm._s(_vm.iconType) + " " + _vm._s(`fa-${_vm.icon}`))])], 1)])]) : _vm.type === 'link' ? _c('div', {
    staticClass: "field"
  }, [!_vm.itemImage && !_vm.redirect ? _c('div', [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _c('br'), _c('span', {
    staticClass: "value"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": "",
      "small": "",
      "color": _vm.iconColor || _vm.color
    }
  }, [_vm._v(_vm._s(_vm.iconType) + " " + _vm._s(`fa-${_vm.icon || 'link'}`))]), _vm._v("\n         \n        " + _vm._s(_vm.value) + "\n      ")], 1)])]) : _vm._e(), _vm.itemImage ? _c('div', [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _c('br'), _c('span', {
    staticClass: "value"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "width": "50",
      "height": "31",
      "src": _vm.itemImage
    }
  })])])]) : _vm._e(), _vm.redirect ? _c('div', [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _c('br'), _vm.link ? _c('span', {
    staticClass: "value"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.link
    }
  }, [_vm._v(_vm._s(_vm.value))])], 1) : _c('span', {
    staticClass: "value"
  }, [_vm._v("\n      " + _vm._s(_vm.value) + "\n    ")])]) : _vm._e()]) : _vm.type === 'download' ? _c('div', {
    staticClass: "field"
  }, [_c('span', {
    staticClass: "value"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "size": "42",
      "color": _vm.iconColor || _vm.color
    }
  }, [_vm._v(_vm._s(_vm.iconType) + " " + _vm._s(`fa-${_vm.icon || 'link'}`))]), _vm._v("\n      Download: " + _vm._s(_vm.value) + "\n    ")], 1)])]) : _c('div', {
    staticClass: "field"
  }, [_c('div', [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _c('br'), _c('span', {
    staticClass: "value"
  }, [_vm._v("\n      " + _vm._s(_vm.value) + "\n    ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };